export { default as DropdownCaret } from './component';
